/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_More_PostsInputs */

const en_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More posts`)
};

const es_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más publicaciones`)
};

const de_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Beiträge`)
};

const zh_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多帖子`)
};

const ar_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المزيد من المنشورات`)
};

const fr_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de messages`)
};

const vi_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm bài viết`)
};

const sw_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machapisho zaidi`)
};

const th_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โพสต์เพิ่มเติม`)
};

const bs_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Više postova`)
};

const ja_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他の投稿`)
};

const ko_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 많은 게시물`)
};

const pt_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais publicações`)
};

const it_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altri messaggi`)
};

const sv_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fler inlägg`)
};

const nl_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer posten`)
};

const da_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flere indlæg`)
};

const nb_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flere innlegg`)
};

const fi_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää virkoja`)
};

const pl_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Więcej postów`)
};

const ru_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Больше постов`)
};

const tr_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla yazı`)
};

const hi_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पोस्ट`)
};

const id_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebih banyak posting`)
};

const ms_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebih banyak hantaran`)
};

const cs_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další příspěvky`)
};

const el_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Περισσότερες θέσεις`)
};

const he_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עוד פוסטים`)
};

const af_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer plasings`)
};

const hu_blog_more_posts = /** @type {(inputs: Blog_More_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Több bejegyzés`)
};

/**
* | output |
* | --- |
* | "More posts" |
*
* @param {Blog_More_PostsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const blog_more_posts = /** @type {((inputs?: Blog_More_PostsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_More_PostsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_blog_more_posts(inputs)
	if (locale === "de") return de_blog_more_posts(inputs)
	if (locale === "zh") return zh_blog_more_posts(inputs)
	if (locale === "ar") return ar_blog_more_posts(inputs)
	if (locale === "fr") return fr_blog_more_posts(inputs)
	if (locale === "vi") return vi_blog_more_posts(inputs)
	if (locale === "sw") return sw_blog_more_posts(inputs)
	if (locale === "th") return th_blog_more_posts(inputs)
	if (locale === "bs") return bs_blog_more_posts(inputs)
	if (locale === "ja") return ja_blog_more_posts(inputs)
	if (locale === "ko") return ko_blog_more_posts(inputs)
	if (locale === "pt") return pt_blog_more_posts(inputs)
	if (locale === "it") return it_blog_more_posts(inputs)
	if (locale === "sv") return sv_blog_more_posts(inputs)
	if (locale === "nl") return nl_blog_more_posts(inputs)
	if (locale === "da") return da_blog_more_posts(inputs)
	if (locale === "nb") return nb_blog_more_posts(inputs)
	if (locale === "fi") return fi_blog_more_posts(inputs)
	if (locale === "pl") return pl_blog_more_posts(inputs)
	if (locale === "ru") return ru_blog_more_posts(inputs)
	if (locale === "tr") return tr_blog_more_posts(inputs)
	if (locale === "hi") return hi_blog_more_posts(inputs)
	if (locale === "id") return id_blog_more_posts(inputs)
	if (locale === "ms") return ms_blog_more_posts(inputs)
	if (locale === "cs") return cs_blog_more_posts(inputs)
	if (locale === "el") return el_blog_more_posts(inputs)
	if (locale === "he") return he_blog_more_posts(inputs)
	if (locale === "af") return af_blog_more_posts(inputs)
	if (locale === "hu") return hu_blog_more_posts(inputs)
	return en_blog_more_posts(inputs)
});